import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';
import { ReportJobCreatedResponse, ReportJobStatusResponse, ReportOficioRepudioRequest, ReportOficioRepudioResponse } from './oficio-repudio.model';

@Injectable({ providedIn: 'root' })
export class OficioRepudioService extends BaseService {
    readonly PATH = SICOM_PATHS.registro.medico.reports.oficioRepudio;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    exportarPdf(request: ReportOficioRepudioRequest): Observable<HttpResponse<ReportOficioRepudioResponse | ReportJobCreatedResponse>> {
        return this.http.post<ReportOficioRepudioResponse | ReportJobCreatedResponse>(`${this.PATH}/exportar-pdf`, request, { observe: 'response' });
    }

    consultarStatus(jobId: string): Observable<ReportJobStatusResponse> {
        return this.http.get<ReportJobStatusResponse>(`${this.PATH}/job/${jobId}/status`);
    }

    baixarPdf(jobId: string): Observable<ArrayBuffer> {
        return this.http.get(`${this.PATH}/job/${jobId}/download`, { responseType: 'arraybuffer' });
    }
}
